module.exports = __webpack_public_path__ + "static/quiz_get_invitation_bg-b369e005ee306c217bb12bad5750433f.svg";